module.exports = __webpack_public_path__ + "img/Duxiaoman.c343b4dd.png";